import { User } from './../../Models/User';
export const LOAD_USER_DETAIL = 'LOAD_USER_DETAIL';
export const LOAD_USER_DETAIL_SUCCESS = 'LOAD_USER_DETAIL_SUCCESS';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const SIGN_OUT_USER = 'SIGN_OUT_USER'
export const LOAD_LIBRARY = 'LOAD_LIBRARY';
export const LOAD_LIBRARY_SUCCESS = 'LOAD_LIBRARY_SUCCESS';


export interface LoadUserDetailAction {
  type: typeof LOAD_USER_DETAIL;
}
export const loadUserDetail = (): LoadUserDetailAction => {
  return {
    type: LOAD_USER_DETAIL
  };
}
export interface LoadUserDetailSuccessAction {
  type: typeof LOAD_USER_DETAIL_SUCCESS;
  payload: {userdetail: User}
}
export const loadUserDetailSuccess = (userdetail: User): LoadUserDetailSuccessAction => {
  return {
    type: LOAD_USER_DETAIL_SUCCESS,
    payload: { userdetail }
  };
}

// Azure AD Login Success Action
export interface LoadUserSuccessAction {
  type: typeof LOAD_USER_SUCCESS;
  payload: {user: User}
}

export const loadUserSuccess = (user: User): LoadUserSuccessAction => {
  return {
    type: LOAD_USER_SUCCESS,
    payload: { user }
  };
}

export interface SignOutUserAction {
  type: typeof SIGN_OUT_USER;
}
export const signOutUser = (): SignOutUserAction => {
  return {
    type: SIGN_OUT_USER
  }
}

/** End Client Lookups */

// Set Page Loading
export const SET_DEALER_GROUP_PAGE_LOADING = 'SET_DEALER_GROUP_PAGE_LOADING';
export interface SetDealerGroupPageLoadingAction {
  type: typeof SET_DEALER_GROUP_PAGE_LOADING,
  payload: {isLoading: boolean}
};
export const setDealerGroupPageLoading = (isLoading: boolean): SetDealerGroupPageLoadingAction => {
  return {
    type: SET_DEALER_GROUP_PAGE_LOADING,
    payload: { isLoading }
  }
};


// Set dealers management page loading
export const SET_DEALER_MANAGEMENT_PAGE_LOADING = 'SET_DEALER_MANAGEMENT_PAGE_LOADING';
export interface SetDealerManagementPageLoadingAction {
  type: typeof SET_DEALER_MANAGEMENT_PAGE_LOADING,
  payload: {isLoading: boolean}
};
export const setDealerManagementPageLoading = (isLoading: boolean): SetDealerManagementPageLoadingAction => {
  return {
    type: SET_DEALER_MANAGEMENT_PAGE_LOADING,
    payload: { isLoading }
  }
};


/** END Add/Edit Organizations */

export type SharedAction =
  LoadUserDetailAction 
| LoadUserSuccessAction
| LoadUserDetailAction
| LoadUserDetailSuccessAction
| SignOutUserAction
| SetDealerGroupPageLoadingAction
| SetDealerManagementPageLoadingAction;
// | SetLoadingOverlayAction;
